import MeaDetailField from "../../../../components/MeaDetailField";
import MeaDetailCard from "../../../../components/MeaDetailCard";
import MeaLink from "../../../../components/MeaLink";
import {
  ToFormatedDateWithWeekday,
  ToFormatedHour,
} from "../../../../utils/dates";
import MeaButton from "../../../../components/MeaButton";
import UpdateSessionTeacherModal from "./UpdateSessionTeacherModal";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import MeaTeacherAvatar from "../../../trainings/components/MeaTeacherAvatar";

const SessionDetailComponent = ({ session, callback }) => {
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  const updateTeacherModalRef = useRef();

  return (
    <>
      <UpdateSessionTeacherModal ref={updateTeacherModalRef} session={session} accessToken={accessToken} schoolId={schoolId} trainingId={trainingId} />
      <MeaDetailCard>
        <MeaDetailField
          field="Classe"
          value={
            <MeaLink
              to={
                "/school/" +
                schoolId +
                "/admin/trainings/" +
                trainingId +
                "/classes/" +
                session?.schedule_item?.classe?.id
              }
            >
              {" "}
              {session?.schedule_item?.classe?.name}{" "}
            </MeaLink>
          }
        />
        <MeaDetailField
          field="Matière"
          value={
            <MeaLink
              to={
                "/school/" +
                schoolId +
                "/admin/trainings/" +
                trainingId +
                "/courses/" +
                session?.schedule_item?.course?.id
              }
            >
              {" "}
              {session?.schedule_item?.course?.name}{" "}
            </MeaLink>
          }
        />

        <MeaDetailField
          field="Enseignant(e)"
          value={
            <MeaTeacherAvatar
              teacher={session?.schedule_item?.teacher}
              schoolId={schoolId}
              trainingId={trainingId}
            />
          }
        />
        <MeaDetailField
          field="Remplaçant(e)"
          value={
            (session?.schedule_item?.teacher?.id !== session?.teacher?.id) &&
            <div ><MeaTeacherAvatar
              teacher={session?.teacher}
              substitute={session?.schedule_item?.teacher}
              schoolId={schoolId}
              trainingId={trainingId}
            /><MeaButton text label="Changer" className="mt-2" onClick={() => {
              if (updateTeacherModalRef.current) {
                updateTeacherModalRef.current.show(() => {
                  callback?.();
                });
              }
            }} /></div> || <span><MeaButton text label="Aucun(e)" onClick={() => {
              if (updateTeacherModalRef.current) {
                updateTeacherModalRef.current.show(() => {
                  callback?.();
                });
              }
            }} /></span>
          }
        />
      </MeaDetailCard>
      <MeaDetailCard>

        <MeaDetailField
          field="Niveau"
          value={
            <MeaLink
              to={
                "/school/" +
                schoolId +
                "/admin/trainings/" +
                trainingId +
                "/levels/" +
                session?.schedule_item?.level?.id
              }
            >
              {" "}
              {session?.schedule_item?.level?.name}{" "}
            </MeaLink>
          }
        />
        <MeaDetailField
          field="Salle"
          value={
            <MeaLink
              to={
                "/school/" +
                schoolId +
                "/admin/trainings/" +
                trainingId +
                "/classrooms/" +
                session?.classroom?.id
              }
            >
              {" "}
              {session?.classroom?.name}{" "}
            </MeaLink>
          }
        />
        <MeaDetailField
          field="Jour Debut"
          value={
            ToFormatedDateWithWeekday(new Date(session?.event?.start_date)) +
            "  " +
            ToFormatedHour(new Date(session?.event?.start_date))
          }
        />
        <MeaDetailField
          field="Jour Fin"
          value={
            ToFormatedDateWithWeekday(new Date(session?.event?.end_date)) +
            "  " +
            ToFormatedHour(new Date(session?.event?.end_date))
          }
        />
        <MeaDetailField
          field="Points"
          value={new Intl.NumberFormat("fr-FR", {
            maximumFractionDigits: 2,
          }).format(session?.points ?? 0)}
        />
      </MeaDetailCard>
    </>
  );
};

export default SessionDetailComponent;
